import { initializeApp } from 'firebase/app';
// TODO: This responsibility should ideally be handled by the backend API
export const firebaseConfig = {
  apiKey: 'AIzaSyBOlUG6ESmIUd7r9y8LKIIQmpcJJwwjiok',
  authDomain: 'flinko-a4a99.firebaseapp.com',
  databaseURL: 'https://testoptimize-f7eb8.firebaseio.com',
  projectId: 'flinko-a4a99',
  storageBucket: 'flinko-a4a99.appspot.com',
  messagingSenderId: '908438350218',
  appId: '1:908438350218:web:ea6fd145d742bdab3fc073',
  measurementId: 'G-G8TQ8S7F37',
};

export const firebaseApp = initializeApp(firebaseConfig);
